module.exports = __webpack_public_path__ + "img/m_logo_title.4e0027bb.png";